import { debounce } from '../../../scripts/utils/debounce';
import { renderContent } from './replaceContent';

Shopify.queryParams = Shopify.queryParams || {};

const debouncedOnSubmit = debounce((event) => {
  onSubmitHandler(event);
}, 500);

const filterAndSortForm = document.querySelector('#FilteringAndSorting:not(.relewise)');
filterAndSortForm?.addEventListener('input', debouncedOnSubmit.bind(this));

function onSubmitHandler(e) {
  e.preventDefault();
  const formData = new FormData(e.target.closest('form'));
  const searchParams = new URLSearchParams(formData).toString();

  renderContent(searchParams, e);
}